import ZeusSdk from '@import-io/doc-sdk';
import { notification } from 'antd';

import { tryParse } from './objectUtils';

// Tries to make sure that error.messages is an array of error messages
function formatError(error) {
  if (error.body) {
    const errorBody = tryParse(error.body);
    if (errorBody) {
      if (Array.isArray(errorBody.message)) {
        error.messages = errorBody.message.map((e) => {
          return { type: 'api', error: e.message };
        });
        return;
      } else if (typeof error.message === 'string') {
        error.messages = [{ type: 'api', error: errorBody.message || error.message }];
        return;
      }
    }
  }
  error.messages = ['An unexpected error occurred'];
}

// Note that this error handler only works for zeus sdk,
export function errorHandler(error) {
  try {
    if (error.status === 401) {
      // User lost session, route user to login
      if (window.location.pathname !== '/login') {
        window.location.href = `/login?redirectUrl=${window.location.href}`;
      }
      throw error;
    } else {
      throw error;
    }
  } catch (e) {
    if (error.status === 409) {
      notification.error({
        message: 'An error occured while saving',
      });
    }
    if (error.status >= 400 && error.status < 500) {
      formatError(error);
    } else {
      console.error('Internal server error', e);
      notification.error({
        message: 'An unknown error occurred',
      });
    }
    throw e;
  }
}

// SDKS ================================ \\

const zeusSdk = new ZeusSdk({ errorHandler: errorHandler });

export default zeusSdk;
